<!-- src/lib/components/Pagination.svelte -->
<script>
  export let currentPage = 1;
  export let totalPages = 1;

  // 이벤트 직접 사용하지 않고, 바깥에서 바인딩
  export let pageChange; // 함수 props로 받는 방식 (callback 전달)

  const visiblePageCount = 10;

  $: startPage = Math.floor((currentPage - 1) / visiblePageCount) * visiblePageCount + 1;
  $: endPage = Math.min(startPage + visiblePageCount - 1, totalPages);

  function goToPage(page) {
    if (page >= 1 && page <= totalPages) {
      pageChange?.(page); // 콜백 호출
    }
  }
</script>

<nav class="pagination mt-5">
  <ul>
    <li>
      <button type="button" class="btn-moveFirst" aria-label="moveFirst"  on:click={() => goToPage(1)} disabled={currentPage === 1}>
        <i class="icon icon-moveFirst"></i>
      </button>
    </li>
    <li>
      <button type="button" class="btn-movePrev" aria-label="movePrev"  on:click={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
        <i class="icon icon-movePrev"></i>
      </button>
    </li>

    {#each Array(endPage - startPage + 1) as _, i}
      <li>
        <button
          type="button"
          class={startPage + i === currentPage ? 'is-active' : ''}
          on:click={() => goToPage(startPage + i)}
        >
          {startPage + i}
        </button>
      </li>
    {/each}

    <li>
      <button type="button" class="btn-moveNext" aria-label="moveNext" on:click={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>
        <i class="icon icon-moveNext"></i>
      </button>
    </li>
    <li>
      <button type="button" class="btn-moveLast" aria-label="moveLast" on:click={() => goToPage(totalPages)} disabled={currentPage === totalPages}>
        <i class="icon icon-moveLast"></i>
      </button>
    </li>
  </ul>
</nav>
